import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { deserialize } from '../../utils/json-typescript-mapper';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { UrlScheme } from '../../models/url-scheme.model';

@Injectable({
    providedIn: 'root'
})
export class MobileApiService {

    constructor(
        private httpClient: HttpClient
    ) { }

    public getURLSchemeForHost(): Observable<UrlScheme> {
        return this.httpClient
            .get<UrlScheme>(`${environment.mobileApiUrl}/v1/urlscheme?vanityUrl=${window.location.host}`)
            .pipe(
                map((urlscheme) => deserialize(UrlScheme, urlscheme)),
                catchError((error: HttpErrorResponse) => {
                    return observableThrowError(error);
                }),
                shareReplay(1)
            );
    }
}
